const xMargin = 20;
const yMargin = 20;

const sides = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
};

const positionCreators = {
  [sides.bottom]: {
    [sides.right]: (x, y) => ({
      x: x + xMargin,
      y: y + yMargin,
    }),
    [sides.left]: (x, y, bBox) => ({
      x: x - bBox.width - xMargin,
      y: y + yMargin,
    }),
  },
  [sides.top]: {
    [sides.right]: (x, y, bBox) => ({
      x: x + xMargin,
      y: y - bBox.height - yMargin,
    }),
    [sides.left]: (x, y, bBox) => ({
      x: x - bBox.width - xMargin,
      y: y - bBox.height - yMargin,
    }),
  },
};

export const getTipCoordinates = (event, tip, container) => {
  if (!event || !tip || !container) {
    console.warn('getTipCoordinates: event or tip or container is missing in');
    return { x: 0, y: 0 };
  }
  const { clientX: x, clientY: y } = event;
  const tipBBox = tip.getBoundingClientRect();
  const outerBBox = container.getBoundingClientRect();
  return getTipPositioningFunction(x, y, tipBBox, outerBBox)(x, y, tipBBox);
};

function getTipPositioningFunction(x, y, tipBBox, outerBBox) {
  const accessors = [
    isTipTooCloseToBottom(y, tipBBox, outerBBox) ? sides.top : sides.bottom,
    isTipTooCloseToRight(x, tipBBox, outerBBox) ? sides.left : sides.right,
  ];
  return positionCreators[accessors[0]][accessors[1]];
}

function isTipTooCloseToBottom(y, tipBBox, outerBBox) {
  //if it's placed to the bottom
  return y + tipBBox.height + yMargin >= outerBBox.y + outerBBox.height;
}

function isTipTooCloseToRight(x, tipBBox, outerBBox) {
  //if it's placed to the right
  return x + tipBBox.width + xMargin >= outerBBox.x + outerBBox.width;
}
